import { useState, useEffect, useContext } from "react";
import { AdminContext } from "../../context/adminContext";
import ErrorMessage from "../../UI/ErrorMessage/ErrorMessage";
import Loader from "../../UI/Loader/Loader";
import CoveredBackground from "../../UI/СoveredBackground/СoveredBackground";
import LittleNotify from "../../UI/Notification/LittleNotify/LittleNotify";
import TestPermitTable from "../../components/TestPermitTable/TestPermitTable";
import ButtonBack from "../../UI/ButtonBack/ButtonBack";

const TestPemitPage = () => {
  const { getTestPermit, postTestPermit } = useContext(AdminContext);
  const [category, setCategory] = useState(null);
  const [users, setUsers] = useState(null);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [search, setSearch] = useState("");
  const [searchChecker, setSearchChecker] = useState(null);
  const [errorNotify, setErrorNotify] = useState(null);

  const closeErrorNotify = () => {
    setErrorNotify(null);
  };
 
  const closeSuccess = () => {
    setSuccess(null);
  };


  useEffect(() => {
    document.title = "Разрешение на тестирование";
    getTestPermit().then((res) => {
      if (res.status === 200) {
        document.title = res.data.category.category;
        setCategory(res.data.category);
        setUsers(res.data.users);
      } else setError(res.data.message);
    });
  }, []);

  const submithandler = (e) => {
    e.preventDefault();
    postTestPermit(e.target["0"].value).then((res) => {
      if (res) {
        if (res.response) {
          if (res.response.data.message) {
            setErrorNotify(res.response.data.message);
            setTimeout(() => {
              setErrorNotify(null);
            }, 12000);
            return;
          }
        } 

        setUsers((prev) => {
          return prev.filter((user) => user.id != e.target["0"].value);
        });
        setSuccess(res.data);
      } else {
        setErrorNotify(res.data.error);
        setTimeout(() => {
          setErrorNotify(null);
        }, 12000);
      }
    });
  }; 

  const searchInput = (e) => {
    setSearch(e.target.value);
    if (e.target.value.length === 0 && searchChecker) {
      setSearchChecker(false);
      setCategory(null);
      setUsers(null);
      getTestPermit().then((res) => {
        if (res.status === 200) {
          setCategory(res.data.category);
          setUsers(res.data.users);
        } else setError(res.data.message);
      });
    }
  };

  const searchHandler = () => {
    if (search.length > 2) {
      setCategory(null);
      setUsers(null);
      setSearchChecker(true);
      getTestPermit(search).then((res) => {
        if (res.status === 200) {
          setCategory(res.data.category);
          setUsers(res.data.users);
        } else setError(res.data.message);
      });
    }
  };


  return (
    <div className="container">
      <div className="admin__retake">
      <ButtonBack shortBtn={true}/> 
        <div className="admin__retake__title">Разрешение на тестирование</div>
        <div style={{ minHeight: 120, position: "relative" }}>
          {!category && !users && !error ? (
            <CoveredBackground>
              <Loader />
            </CoveredBackground>
          ) : error ? (
            <ErrorMessage message={error} />
          ) : (
            <>
              <div className="admin__retake__title">
                Категория: "{category.category}"
              </div>
 
              <div>
                <input
                  type="text"
                  className="input__search"
                  placeholder="Поиск по ФИО и ИИН"
                  value={search}
                  onInput={searchInput}
                />
                <button
                  className="search__btn"
                  style={{ marginLeft: 15 }}
                  disabled={search.length <= 2 && "disabled"}
                  onClick={searchHandler}
                >
                  Найти
                </button>
              </div>

              <TestPermitTable users={users} submithandler={submithandler} />
            </>
          )}
        </div>
      </div>

      {errorNotify && (
        <LittleNotify
          title={errorNotify}
          close={closeErrorNotify}
          error={true}
        />
      )}
      {success && <LittleNotify title={success} close={closeSuccess} />}
    </div>
  );
};

export default TestPemitPage;
